import React from "react";

type Props = {
  children: React.ReactNode;
  onHover: (hover: boolean) => void;
};

export default function CreateCharacter({ children, onHover }: Props): JSX.Element {
  return (
    <div
      className="absolute inset-y-[--boundary-offset-x] right-[--boundary-offset-x] w-[--customization-side-w] flex flex-col card pt-5 rounded-tl-none"
      onMouseEnter={() => onHover(true)}
      onMouseLeave={() => onHover(false)}
    >
      <div className="relative overflow-y-auto overflow-x-clip mb-2 content-start flex flex-col grow gap-2">
        {children}
      </div>
    </div>
  );
}
